import React, { useState, useEffect } from "react";
import "./index.scss";
import phonebanner from "@/assets/images/phonebanner.png";
import { connect } from "react-redux";
import ForddTopTit from "@/components/forddtopt";
import { setTit } from "@/utils/settit";
// import {telephone} from '@/utils/telephone'
import { getSecureLineTelephone } from "@/api";
import request from "@/utils/request";
import { Toast } from "antd-mobile";

const mapStateToProps = (state) => ({
  tenant: state.getIn(["tenantReducer", "tenant"]),
});

const SLine = (props) => {
  //安全专线
  const [telephone, setTelephone] = useState("");
  const [loading, setLoading] = useState(false);
  // let {tenant} = props
  useEffect(() => {
    document.title = `「${setTit()}」 安全专线`;
    return () => {
      document.title = "";
    };
  }, []);

  useEffect(() => {
    if (window.location.hostname === 'app-web.hycx.com') {
      setTelephone('852800969328');
      return;
    }
    setLoading(true);
    Toast.loading("Loading...", 0, () => {}, true);
    const hostname = window.location.hostname === "qszx-h5.prod.yunwuchuxing.com" 
      ? "fzxh5.kunpengchuxing.com" 
      : window.location.hostname;
      
    request
      .get(getSecureLineTelephone + "?domain=" + hostname)
      .then((res) => {
      setLoading(false);
      Toast.hide();
      if (res?.data?.data) {
        setTelephone(res.data.data);
      }
      });
  }, []);

  const noSet = () => {
    Toast.fail("尚未配置安全专线!!!", 2);
  };

  return (
    <div className="SLine__box">
      {/* <p className="top-title">本次服务由「{tenant}」为您提供</p> */}
      <ForddTopTit />
      <div className="SLine-show">
        <img className="phone-banner" src={phonebanner} alt="" />
        <div className="text-show">
          <h2>
            安全专线只处理人身安全问题，如用户多次占用安全专线投诉非安全问题，将有可能被暂停服务。
          </h2>
          <div className="text-list">
            <h3>什么是安全专线</h3>
            <div>
              安全专线是为了乘车人及亲友、警方提供的绿色安全通道。在紧急情况下，用户拨打专线能快速联络安全专员。
            </div>
          </div>
          <div className="text-list">
            <h3>安全专线处理哪些问题</h3>
            <div>
              作为紧急求助的通道，安全专线只处理在行程前后用户人身安全受到威胁或损害的情况，如:乘车时与他人发生肢体冲突、因乘车遭遇性骚扰、联系不上乘车的亲友等。如果您遇到了车费纠纷、司机态度恶劣、物品遗失等问题，请联系客服获取帮助。
            </div>
          </div>
          <div className="text-list">
            <h3>请不要随意拨打占用线路</h3>
            <div>
              为了保证线路通畅，避免真正需要紧急求的用户被耽误，请勿随意拨打安全专线。
            </div>
          </div>
        </div>
      </div>
      <footer>
        {!loading && !telephone ? (
          <a onClick={noSet}>呼叫安全专线</a>
        ) : (
          <a href={`tel:${telephone}`}>呼叫安全专线</a>
        )}
      </footer>
    </div>
  );
};
export default connect(mapStateToProps)(SLine);
